import React from 'react';
import PlayTestVimeoContainer from 'containers/PlayTestVimeoContainer';

function PlayTestVimeoPage() {
    return (
        <PlayTestVimeoContainer />
    )
}

export default PlayTestVimeoPage;